module.exports = __webpack_public_path__ + "img/mob-apps.62a55ab3.svg";